import Vue from 'vue'
import VueI18n from 'vue-i18n'
import dateTimeFormats from '@/locales/formats/dateTimeFormats'
import numberFormats from '@/locales/formats/numberFormats'

Vue.use(VueI18n)

Vue.mixin({
    methods: {
        /**
         * Due to the confusing fallback handling in $t and $te this shall
         * provide a convenient way to check for translations with fallbacking,
         * just by giving the corresponding key.
         * @see README.md
         */
        tExists (key) {
            return !!this.$t(key).length && this.$t(key) !== key
        },
        /**
         * As Intl.NumberFormat doesn't support changing the group separator
         * we need a clone of "$n" providing a way to do so.
         * Declare "groupSeparator" in numberFormats to change the separator.
         */
        nEnhanced (number, numberFormatKey, locale) {
            numberFormatKey = numberFormatKey || 'currency'
            locale = locale || this.$i18n.locale
            const numberFormat = this.$i18n.getNumberFormat(locale)[numberFormatKey]
            if (numberFormat === undefined || !numberFormat.groupSeparator) return this.$n.apply(this, arguments)
            const formatter = new Intl.NumberFormat(locale, numberFormat)
            const parts = formatter.formatToParts(number)

            parts.forEach(part => {
                if (part.type === 'group') part.value = numberFormat.groupSeparator
            })

            return parts.reduce((memo, part) => memo + part.value, '')
        }
    }
})

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    messages: loadLocaleMessages(),
    dateTimeFormats,
    numberFormats
})
